import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import OurService from "@/pages/OurService";
import CareSupport from "@/pages/CareSupport";
import LocalArea from "@/pages/LocalArea";
import EducationOutcomes from "@/pages/EducationOutcomes";
import Team from "@/pages/Team";
import Referrals from "@/pages/Referrals";
import OutreachService from "@/pages/OutreachService";
import YoungKings from "@/pages/YoungKings";

let lenisInstance = null;
export const getLenis = () => lenisInstance;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-cream px-6 text-center">
          <p className="max-w-md font-display text-2xl text-ink">
            Something went wrong. Please refresh the page.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = getLenis();
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppShell() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    lenisInstance = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);

  return (
    <>
      <ScrollManager />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/our-service" element={<OurService />} />
          <Route path="/care-support" element={<CareSupport />} />
          <Route path="/local-area" element={<LocalArea />} />
          <Route path="/education-outcomes" element={<EducationOutcomes />} />
          <Route path="/team" element={<Team />} />
          <Route path="/referrals" element={<Referrals />} />
          <Route path="/outreach-service" element={<OutreachService />} />
          <Route path="/young-kings-programme" element={<YoungKings />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AppShell />
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
